export const SIDEBAROPEN = '@sidebaropen';
export const SIDEBARSHOW = '@sidebarshow';
export const SIDEBARCOLLAPSED = '@sidebarcollapsed';
